<template>
    <div class="container-fluid">
        <route-header>
            <h3>{{ $t('labels.nav.settings') }}</h3>
        </route-header>
        <div class="row">
            <div class="col">
                <nav-secondary-settings></nav-secondary-settings>
            </div>
        </div>
        <div class="row">
            <div class="col-12 mb-4">
                <users />
            </div>
            <div class="col-12 col-sm-6" v-if="auth.can['roles']">
                <roles />
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Settings',
  computed: {
    ...mapState({
      auth: state => state.auth
    })
  }
}
</script>
